import styled from "styled-components";

export const Title = styled.div`
  font: normal normal 600 30px/27px Open Sans;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 40px;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;

export const DownloadTemplateBtnWrapper = styled.div`
  width:256px;
`;
